import actionCreatorFactory from 'typescript-fsa';
import * as constants from './constants';
import { ObservationV2 } from '../../../api/api';

const actionCreator = actionCreatorFactory('weatherData');

export const getWeatherDatas = actionCreator.async<any, ObservationV2[]>(constants.constants.GET_WEATHERDATA);
export const getBackendDmiDataAction = actionCreator.async<any, ObservationV2[]>(constants.constants.GET_BACKEND_DMI_DATA);
